import Firebase from 'firebase'
import ReactGA from 'react-ga'
import { toast } from 'react-toastify'

const logOut = () => {
  toast('Logged out')
  ReactGA.event({
    category: 'User',
    action: 'Logged out',
  })
  return Firebase.auth().signOut()
}

export default logOut



// WEBPACK FOOTER //
// ./src/actions/logOut.js